import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import UploadDragAndDrop from '../uploadDragAndDrop/uploadDragAndDrop';
import Label from '../../atoms/label/label';
import FormValidation from '../../atoms/formEnums/formValidation';
import { mapDispatchToProps } from '../../../store/externalCalls/api/uploadFilesApi';

const FormUploadAsync = (props) => {
  const {
    id,
    validation,
    label,
    helpText,
    fileType,
    value,
    onCompleted,
    onUpload,
    onError,
  } = props;

  const [currentValue, setCurrentValue] = useState(value);

  const handlerCompleted = (event) => {
    const { uploadURL } = event.successful[0].response;
    const publicFolder = uploadURL.substr(uploadURL.lastIndexOf('/'));
    const fileName = event.successful[0].name;
    const publicFileUrl = `${process.env.REACT_APP_BACKEND_URL + process.env.REACT_APP_PUBLIC_UPLOADS + publicFolder}/${fileName}`;
    const request = { ...event };

    request.target = { value: publicFileUrl };
    setCurrentValue(publicFileUrl);
    onCompleted(request);
  };

  const handlerUpload = (event) => {
    const request = { ...event };
    request.target = { value: '' };
    onUpload(request);
  };

  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  return (
    <div>
      <div className={`form-group row text-${validation}`}>
        { label !== ''
          && (
            <Label helpText={helpText}>{label}</Label>
          )}
        <div className="col-sm-8">
          <UploadDragAndDrop
            id={id}
            onError={onError}
            onCompleted={handlerCompleted}
            onUpload={handlerUpload}
            fileType={fileType}
          />
          <div>{currentValue}</div>
        </div>
      </div>
    </div>
  );
};

FormUploadAsync.propTypes = {
  /**
   * Id of upload async input
   */
  id: PropTypes.string,
  /**
   * Select form status, it is a FormValidation enum
   */
  validation: PropTypes.oneOf(Object.values(FormValidation)),
  /**
   * Name of input attribute
   */
  label: PropTypes.string,
  /**
   * Input help text
   */
  helpText: PropTypes.string,
  /**
   * value resource reference
   */
  value: PropTypes.node,
  /**
   * Completed event function
   */
  onCompleted: PropTypes.func,
  /**
   * Error event function
   */
  onError: PropTypes.func,
  /**
   * Fired when upload starts.
   */
  onUpload: PropTypes.func,
  /**
   * Format of the accepted files
   */
  fileType: PropTypes.arrayOf((PropTypes.string)),
};

FormUploadAsync.defaultProps = {
  id: '',
  validation: FormValidation.PENDING,
  label: '',
  helpText: '',
  fileType: '',
  value: '',
  onCompleted: () => {},
  onError: () => {},
  onUpload: () => {},
};

export default connect(null, mapDispatchToProps)(FormUploadAsync);
